@if (routerLink()) {
  <a
    #link
    [class]="variant()"
    [routerLink]="routerLink()"
    [attr.aria-label]="target() === '_blank' ? `${label} (opens in a new tab)` : label"
  >
    <ng-container [ngTemplateOutlet]="hrefLink"></ng-container>
  </a>
} @else {
  <a
    #link
    [class]="variant()"
    [href]="href()"
    [target]="target()"
    [attr.aria-label]="target() === '_blank' ? `${label} (opens in a new tab)` : label"
  >
    <ng-container [ngTemplateOutlet]="hrefLink"></ng-container>
  </a>
}

<ng-template #hrefLink>
  <ng-content />
</ng-template>
